import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

// Guest Portal
import GuestHome from "./views/guest-portal/pages/Home/GuestHome";
import Login from "./views/guest-portal/Auth/Login";
import Register from "./views/guest-portal/Auth/Register";
import ForgotPassword from "./views/guest-portal/Auth/ForgotPassword";
import ResetPassword from "./views/guest-portal/Auth/ResetPassword";
import {
  AdminProtectedRoute,
  ProtectedRoute,
  WithAdminAuthRoute,
  WithAuthRoute,
  WithoutAdminAuthRoute,
  WithoutAuthRoute
} from "./routes";

// Client Portal
import EnvelopeCreate from "./views/client-portal/Envelope/create";
import Recipients from "./views/client-portal/Recipients";
import Settings from "./views/client-portal/Settings";
import Manage from "./views/client-portal/Envelope/Manage";
import Layout from "./views/client-portal/Layout";
import ViewEnvelope from "./views/client-portal/Envelope/Manage/ViewEnvelope";
import Billing from "./views/client-portal/Billing";
import BillingHistory from "./views/client-portal/Billing/BillingHistory";
import CreditHistory from "./views/client-portal/Billing/CreditHistory";
import PricingPlan from "./views/client-portal/Billing/PricingPlan";
import BillingOverview from "./views/client-portal/Billing/BillingOverview";
import SettingIntegration from "./views/client-portal/Settings/Integration";
import SettingPreferences from "./views/client-portal/Settings/Preferences";
import SettingUsers from "./views/client-portal/Settings/Users";
import SettingAccount from "./views/client-portal/Settings/Account";
import UserTemplates from "./views/client-portal/Templates/Index";
import CompletedManageEnvelope from "./views/client-portal/Envelope/Manage/CompletedManageEnvelope";
// import CustomerViewPortal from "./views/client-portal/Envelope/CustomerViewPortal";
import SettingUserGroup from "./views/client-portal/Settings/Users/UserGroupList";
import DraftManageEnvelope from "./views/client-portal/Envelope/Manage/DraftManageEnvelope";
import BoxCloud from "./views/client-portal/Settings/Integration/BoxCloud";
import SleeveFilesSummaryGenerator from "./views/client-portal/Envelope/Manage/ViewSleevesFiles/SleeveFilesSummaryGenerator";

import EnvFiles from "./views/client-portal/Envelope/Manage/EnvFiles";
// Admin Portal
import AdminPortal from "./views/admin-portal";
import AdminPortalUsers from "./views/admin-portal/Users";
import AdminPortalSubscribers from "./views/admin-portal/Subscribers";
import AdminPortalPlans from "./views/admin-portal/Plans";
import AdminPortalLogin from "./views/admin-portal/Login";
import GoogleDrive from "./views/client-portal/Settings/Integration/GoogleDrive";
import DropBoxCloud from "./views/client-portal/Settings/Integration/DropBox";
import AdminBlog from "./views/admin-portal/Blogs";
import AdminModifyBlog from "./views/admin-portal/Blogs/Modify";
import Admin2FA from "./views/admin-portal/2FA";
// import ExpiredDocument from "./views/client-portal/Envelope/Manage/ViewEnvelope/ExpiredDocument";
import SummaryPrompt from "./views/admin-portal/Summary";
import DashbordPage from "./views/admin-portal/Dashbourd/Pages";
import Files from "./views/admin-portal/Files";
import Template from "./views/admin-portal/Templates";
import TemplateEditorWrapper from "./views/admin-portal/Templates/TemplateEditorWrapper";
import EditQuestions from './views/admin-portal/Templates/EditQuestions';

// Customer Portal
// import CustomerDocumentExpired from "./views/customer-portal/CustomerDocumentExpired";
import CustomerPortalStopReminder from "./views/customer-portal/StopReminder";
import CustomerPortalSms from "./views/customer-portal/CustomerPortalSms";
import CustomerPortal from "./views/customer-portal";

import { enableGlobalFileValidation } from "./components/FileTypeValidator";
import GuestLayout from "./views/guest-portal/Layout";

import Negotiation from "./views/client-portal/Negotiation";

import Contract from './views/client-portal/Contract/index'

import NegotiationReview from "./views/Negotiation-Review-Portal/NegotiationReview";
import NegotiationManage from "./views/client-portal/Negotiation/Manage/NegotiationManage";
import NegotiationCreateLayout from "./views/client-portal/Negotiation/layout/NegotiationCreateLayout";

import NegotiationVersionComparison from "./views/client-portal/Negotiation/Manage/NegotiationVersionComparison";
import OneDriveIntegration from "./views/client-portal/Settings/Integration/OneDriveIntegration";

import Dashboard from "./views/client-portal/Dashboard";

import TemplateSummary from "./views/admin-portal/Templates/TemplateSummary";
import ElectronicSignaturePage from "./views/guest-portal/pages/ElectronicSignaturePage/ElectronicSignaturePage";
import BecomeAPartner from "./views/guest-portal/pages/Partner/BecomeAPartner";
import PartnerSignup from "./views/guest-portal/pages/Partner/PartnerSignup";

import TermsConditions from "./views/guest-portal/pages/TermsConditions";
import PrivacyPolicy from "./views/guest-portal/pages/PrivacyPolicy";
import ProductPage from "./views/guest-portal/pages/Product/ProductPage";

function App() {

  useEffect(() => {
    const cleanup = enableGlobalFileValidation({
      showToast: true,
      resetOnError: true,
      onValidFiles: (validation, target) => {
      },
      onInvalidFiles: (validation, target) => {
      }
    });

    return cleanup;
  }, [])

  return (
    <>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick
        rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />

      <Routes>
        <Route path="/" element={<WithoutAuthRoute />}>
          <Route element={<GuestLayout />}>
            <Route index element={<GuestHome />} />
            <Route path="/" element={<GuestHome />} />
            <Route path="sign-up" element={<Register />} />
            <Route path="login" element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="e-signature-laws" element={<ElectronicSignaturePage />} />
            <Route path="become-a-partner" element={<BecomeAPartner />} />
            <Route path="partner-signup" element={<PartnerSignup />} />
            <Route path="terms-condition" element={<TermsConditions />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="product" element={<ProductPage />} />
          </Route>
        </Route>

        <Route path="/customer-portal/:id" element={<CustomerPortal />} />
        <Route path="/customer-portal/stop-reminder/:uuid/:id" element={<CustomerPortalStopReminder />} />
        {/* <Route path="/client-portal/sleeve/view/:id" element={<CustomerViewPortal />} /> */}
        {/* <Route path="/customer/document/:uuid/e/:id" element={<CustomerDocumentExpired />} /> */}
        <Route path="/negotiation/view/:id" element={<NegotiationReview />} />

        <Route path="/" element={<WithAuthRoute />}>
          <Route path="/" element={<Layout />}>
            <Route path="/client-portal" element={<Dashboard />} />
            <Route path="/client-portal/sleeve" element={<EnvelopeCreate />} />
            <Route path="/client-portal/sleeve/edit/:uuid/:id" element={<EnvelopeCreate />} />
            <Route path="/client-portal/sleeve/edit/:uuid/:id/:direct" element={<EnvelopeCreate />} />

            <Route path="/client-portal/contract" element={<Contract />} />

            <Route path="/client-portal/negotiation-contract" element={<Negotiation />} />
            <Route path="/client-portal/negotiation-contract/create" element={<NegotiationCreateLayout />} />
            <Route path="/client-portal/negotiation-contract/create/:id" element={<NegotiationCreateLayout />} />
            <Route path="/client-portal/negotiation-contract/create/:uuid/:id" element={<NegotiationCreateLayout />} />
            <Route path="/client-portal/negotiation-contract/view/:uuid" element={<NegotiationManage />} />
            <Route path="/client-portal/negotiation-contract/version-comparison/:uuid" element={<NegotiationVersionComparison />} />

            <Route path="/recipients" element={<Recipients />} />

            <Route path="/templates" element={<UserTemplates />} />
            <Route path="/settings" element={<Settings />}>
              <Route path="/settings" element={<SettingAccount />} />
              <Route path="/settings" element={<ProtectedRoute />}>
                <Route path="/settings/users" element={<SettingUsers />} />
                <Route path="/settings/users/group" element={<SettingUserGroup />} />
                <Route path="/settings/preferences" element={<SettingPreferences />} />
                <Route path="/settings/integration" element={<SettingIntegration />} />
                <Route path="/settings/integration/one-drive" element={<OneDriveIntegration />} />
              </Route>
              <Route path="/settings/integration/google-drive-success"
                element={<GoogleDrive type={1} />} />
              <Route path="/settings/integration/google-drive-error"
                element={<GoogleDrive type={2} />} />
              <Route path="/settings/integration/drop-box-success"
                element={<DropBoxCloud type={1} />} />
              <Route path="/settings/integration/drop-box-error"
                element={<DropBoxCloud type={2} />} />
              <Route path="/settings/integration/box-success"
                element={<BoxCloud type={1} />} />
              <Route path="/settings/integration/box-error"
                element={<BoxCloud type={2} />} />
            </Route>
            <Route path="/manage" element={<Manage />} />
            <Route path="/manage/negotiation" element={<Negotiation />} />

            <Route path="/manage/draft" element={<DraftManageEnvelope />} />
            <Route path="/manage/files" element={< EnvFiles />} />
            <Route path="/manage/files/summary/:randomId" element={<SleeveFilesSummaryGenerator />} />
            <Route
              path="/manage/my-files/document-summary/:envelopeId/:fileName"
              element={<SleeveFilesSummaryGenerator />}
            />
            <Route path="/manage/completed" element={<CompletedManageEnvelope />} />
            <Route path="/manage/:id" element={<ViewEnvelope tabType={``} />} />
            <Route path="/manage/:id/awaiting" element={<ViewEnvelope tabType={"1"} />} />
            <Route path="/manage/:id/needs-review" element={<ViewEnvelope tabType={"2"} />} />
            <Route path="/manage/:id/approved" element={<ViewEnvelope tabType={"3"} />} />
            <Route path="/manage/:id/message" element={<ViewEnvelope tabType={"message"} />} />
            {/* <Route path="/manage/:id/expired-document" element={<ExpiredDocument />} /> */}

            <Route path="/" element={<ProtectedRoute />}>
              <Route path="/billing" element={<Billing />}>
                <Route path="/billing" element={<BillingOverview />} />
                <Route path="/billing/history" element={<BillingHistory />} />
                <Route path="/billing/credit-history" element={<CreditHistory />} />
                <Route path="/billing/pricing" element={<PricingPlan />} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="/back-admin" element={<WithAdminAuthRoute />}>
          <Route path="/back-admin" element={<AdminPortal />}>
            <Route index element={<DashbordPage />} />

            <Route path="/back-admin/subscribers" element={<AdminPortalSubscribers />} />
            <Route path="/back-admin/2fa" element={<Admin2FA />} />
            <Route path="/back-admin/plans" element={<AdminPortalPlans />} />
            <Route path="/back-admin/blogs" element={<AdminBlog />} />
            <Route path="/back-admin/blogs/create" element={<AdminModifyBlog />} />
            <Route path="/back-admin/blogs/:id/edit" element={<AdminModifyBlog />} />
            <Route path="/back-admin/adminportal" element={<AdminPortalUsers />} />
            <Route path="/back-admin/summary-prompt" element={<SummaryPrompt />} />
            <Route path="/back-admin/template" element={<Template />} />
            <Route path="/back-admin/template/:templateUuid" element={<TemplateEditorWrapper />} />
            <Route path="/back-admin/template/:templateUuid/edit-questions" element={<EditQuestions />} />
            <Route path="/back-admin/template/:templateUuid/summary-questions" element={<TemplateSummary />} />
            <Route path="/back-admin/files" element={<Files />} />
          </Route>
        </Route>

        <Route path="/back-admin/login" element={<WithoutAdminAuthRoute />}>
          <Route index element={<AdminPortalLogin />} />
        </Route>

        <Route path="/:id" element={<CustomerPortalSms />} />

      </Routes >
    </>
  );
}

export default App;